export const ACCESS_ROLES = 'accessing Roles';
export const ACCESS_SUBJECT_ROLES = 'accessing Subject Roles';
export const ASSIGN_ROLES = 'assigning Roles';
export const DELETE_ROLES = 'deleting Roles';
export const IDP_ROLE_TOOLTIP= 'Role Mapped From Identity Provider';
export const LIAM= 'LIAM';
export const CUSTOMER_IDP= 'CustomerIdP';
export const ROLES= 'Roles';
